<template>
  <div class="display-value-component">
    <div class="label">{{ label }}</div>
    <div class="value">{{ value }}</div>
  </div>
</template>

<script>

export default {
  name: 'DisplayValueComponent',
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      required: true
    },
  }
}
</script>

<style lang="stylus" scoped>

.label
    color: $shuttle-gray
    m-font-size(12, 14)
.value 
  text-align: center

</style>